import React, { Fragment } from 'react';
import { Button } from 'reactstrap';

const EmailInterval = ({
  is_active, email_interval, handleOnSelect, intervals, name
}) => {
  if (!is_active) return null;

  const emailInterval = intervals.map(interval => (
    <p>
      <label onClick={() => handleOnSelect(interval.value)}>
        <input
          className="mr-2"
          type="radio"
          key={interval.value}
          value={interval.value}
          name={name}
          checked={email_interval === interval.value}
        />
        {interval.display}
      </label>
    </p>
  ));

  return (
    <Fragment>
      <p> How often would you like to receive email reports? </p>
      {emailInterval}
    </Fragment>
  );
}

const ConfigView = ({
  userName, userRole,
  is_active,
  is_unsubscribed,
  email_interval,
  handleOnCheck,
  handleOnSelect,
  updateEmailReportConfig,
  checkboxLabel,
  intervals,
  name
}) => {
  return (
    <div className="card card-body bg-light">
      <p>
        <span className="font-weight-bold">{userName}</span>
        <br />
        <span className="">{userRole}</span>
        <hr />
      </p>
      <p>
        <label>
          <input
            type="checkbox"
            checked={is_active}
            className="mr-2"
            onClick={handleOnCheck}
          />
          {checkboxLabel}
        </label>
        <span> {is_unsubscribed ? '(Unsubscribed)' : ''} </span>
      </p>
      <EmailInterval
        is_active={is_active}
        email_interval={email_interval}
        handleOnSelect={handleOnSelect}
        intervals={intervals}
        name={name}
      />
      <p>
        <Button
          className="email-settings-save-btn"
          onClick={updateEmailReportConfig}
        >
          Save Email Settings
        </Button>
      </p>
    </div>
  )
}

export default ConfigView;



// WEBPACK FOOTER //
// ./src/components/emailConfig/ConfigureEmailView.js